import { Pipe, PipeTransform } from '@angular/core';
import { EstadoHomologacionHelper } from '../../helpers/solicitudes/EstadoHomologacionHelper';

@Pipe({
    name: 'stateRequestNumberToStringPipe',
    standalone: false
})
export class StateRequestNumberToStringPipe implements PipeTransform {
  transform(codigoEstado: number | string): string {
    return EstadoHomologacionHelper.obtenerNombreGrupo(codigoEstado);
  }
}
